import { searchUsers } from './../../../+state/users/users.actions';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbService } from '@boma/ui';
import { from, Observable } from 'rxjs';
import { loadUsers } from '../../../+state/users/users.actions';
import { UsersFacade } from '../../../+state/users/users.facade';
import { IUser } from '@boma/administration-portal/shared/entities';

@Component({
  selector: 'boma-users-index',
  templateUrl: './users-index.component.html',
  styleUrls: ['./users-index.component.scss'],
})
export class UsersIndexComponent implements OnInit {
  columns = [
    { field: 'firstName', header: 'First Name' },
    { field: 'surname', header: 'Surname' },
    { field: 'phoneNumber', header: 'Phone Number' },
    { field: 'email', header: 'Email' },
    { field: 'id', header: 'User ID' },
  ];
  users$: Observable<IUser[]>;
  loaded$ = this.usersFacade.loaded$;

  constructor(
    public usersFacade: UsersFacade,
    private breadcrumbService: BreadcrumbService,
    private router: Router
  ) {
    this.breadcrumbService.setItems([{ label: 'Users' }]);
  }

  search(query: string){
    this.usersFacade.dispatch(searchUsers({ query }));
  }

  ngOnInit(): void {
    this.usersFacade.dispatch(loadUsers());
    this.users$ = this.usersFacade.allUsers$;
  }

  onViewSelection(data: IUser) {
    this.router.navigate(['/', 'users', 'user', data.id]);
  }
}
